export const DISCOVERING_FEATURE_VISIBILITY_DAYS = 30;

// TODO: check release dates and remove them after 30 days
